import { z } from 'zod';
import { paymentStatusCommonSchema } from '../../common';

export const invoiceStatusSchema = z.enum([
  ...paymentStatusCommonSchema.options,
  'pending',
  'on_going',
  'cancelled',
]);
export type InvoiceStatus = z.infer<typeof invoiceStatusSchema>;
